var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewPhone = function SvgNewPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #1eb9d5;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_mail",
    transform: "translate(-318 -184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    className: "cls-1",
    width: 16,
    height: 16,
    transform: "translate(318 184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    className: "cls-2",
    d: "M129.433,132.293a3.637,3.637,0,0,1-1.243-.222,13.2,13.2,0,0,1-7.878-7.879,3.6,3.6,0,0,1-.184-1.767,3.691,3.691,0,0,1,1.9-2.7,3.621,3.621,0,0,1,1.733-.432.406.406,0,0,1,.4.321l.638,2.976a.4.4,0,0,1-.11.372l-1.089,1.09a10.693,10.693,0,0,0,4.739,4.739l1.089-1.09a.406.406,0,0,1,.373-.109l2.975.637a.408.408,0,0,1,.322.4,3.625,3.625,0,0,1-.433,1.734,3.681,3.681,0,0,1-2.7,1.894,3.471,3.471,0,0,1-.524.039Zm-6-12.17a2.846,2.846,0,0,0-2.357,3.792,12.319,12.319,0,0,0,7.392,7.392,2.845,2.845,0,0,0,3.792-2.356l-2.421-.519-1.138,1.138a.406.406,0,0,1-.46.081,11.505,11.505,0,0,1-5.508-5.509.407.407,0,0,1,.08-.46l1.138-1.138Z",
    transform: "translate(199.91 66.707)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/newPhone.cdf4484f.svg";
export { ForwardRef as ReactComponent };